import {
  Component,
  EventEmitter,
  Output,
  forwardRef,
  OnInit,
  ElementRef,
  Input,
  Host,
  Optional
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ValidationErrors
} from '@angular/forms';
import { NgxsOnInit } from '@ngxs/store';
import { AbstractField } from './abstract-field.component';

const customValueProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PasswordFieldComponent),
  multi: true
};

@Component({
  selector: 'password-field',
  inputs: [...AbstractField.inputs, 'type', 'maxLength'],
  outputs: [...AbstractField.outputs],
  template: `
    <div
      [floatingLabel]="model"
      [focus]="focused"
      [ngClass]="{
        'validation-failed':
          (showValidation || inp.dirty || inp.touched) &&
          required &&
          (!model || model == '' || !inp.valid)
      }"
    >
      <label for="FIELD={{ id }}">{{ label + (required ? '*' : '') }}</label>
      <input
        [autocomplete]="autocomplete"
        [attr.name]="autocomplete"
        id="FIELD-{{ id }}"
        [(ngModel)]="model"
        [placeholder]="label + (required ? ' *' : '')"
        class="form-control"
        (focus)="focused = true"
        (blur)="onBlur($event)"
        (ngModelChange)="onChange($event)"
        [disabled]="disabled"
        [required]="required"
        #inp="ngModel"
        [type]="type"
        [attr.maxLength]="maxLength ? maxLength : null"
        password
      />
      <div
        *ngIf="
          errors && errors.suggestions && errors.suggestions.length > 0 && model
        "
        class="password-suggestion"
      >
        <div *ngFor="let suggestion of errors.suggestions">
          {{ suggestion }}
        </div>
      </div>
      <div
        *ngIf="errors && (errors.password || errors.message) && model"
        class="password-suggestion"
      >
        <div>{{ errors.password || errors.message }}</div>
      </div>
    </div>
  `,
  providers: [customValueProvider]
})
export class PasswordFieldComponent extends AbstractField {
  type;
  maxLength = 0;
  @Input() errors: any = {};
  constructor() {
    super();
  }
}
